module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-index-thumbnails-1920x1080-ca85a238df24876865bfc294535d5426.jpg";